<ng-container>
  <h4 class="flex-row align-items-center" data-cy="creating-user-dialog-title">
    <i class="ri-refresh-line spin"></i>
    {{ data.icon | translate }}
  </h4>
</ng-container>

<div>
  {{ data.message | translate }}
</div>
